import { Tag } from '@brg/api';
import { createSlice } from '@reduxjs/toolkit';
import { ADMIN_TAGS_TYPE } from '_deziiign/main/pages/MainTagAdminPage/types';
import { fetchAllCategory, fetchCategoryEdit, fetchCurrentPlatformData, fetchPlatformCategoryOpt, updateEditedCategory } from 'shared/actions/tagAdminActions';

export interface IPlatform {
    id: string;
    appName: string;
    context: string;
    url: string;
    entityTypes?: string[];
    entityTypesEduTags?: string[];
    entityTypesRequiredTags?: string[];
}

interface EditCategory {
    mainTag: Tag<'Local'>;
    childrens: Tag<'Local'>[];
}

interface TagAdminSliceState  {
    platforms: IPlatform[];
    categories: Tag<'Local' | 'Global'>[];
    currentPlatform?: {
        platform: IPlatform | null,
        categories: Tag<'Local' | 'Global'>[];
        editCategory: EditCategory
    }
    isLoading: boolean;
    isEditMode: boolean;
    type: ADMIN_TAGS_TYPE
}


export const TagAdminSlice = createSlice({
    name: 'tagAdmin',
    initialState: {
        categories: [],
        platforms: [],
        currentPlatform: {
            platform: null,
            categories: [],
            editCategory: null
        },
        isLoading: false,
        isEditMode: false,
        type: ADMIN_TAGS_TYPE.normal
    },
    reducers: {
        toggleEditMode: (state, action) => {
            state.isEditMode = action.payload
        },
        clear: (state) => {
            state = {  
                categories: [],
                platforms: [],
                currentPlatform: {
                    platform: null,
                    categories: [],
                    editCategory: null
                },
                isLoading: false,
                isEditMode: false
            }
        },
        setTagsType: (state,action) => {
            state.currentPlatform = action.payload?.currentPlatform
            state.isEditMode = action.payload.isEditMode
            state.type = action.payload.type
        }
    },
    extraReducers: {
        // Запрос всех категорий для текущей платформы по entityType
        [fetchPlatformCategoryOpt.fulfilled.toString()]: (state, action) => {
            state.platforms = action.payload;
            state.isLoading = false;
        },
        [fetchPlatformCategoryOpt.rejected.toString()]: (state, action) => {
            state.platforms = [];
            state.isLoading = false;
        },
        [fetchPlatformCategoryOpt.pending.toString()]: (state, action) => {
            state.platforms = [];
            state.isLoading = true;
        },

        //Запрос всех доступных категорий в базе
        [fetchAllCategory.fulfilled.toString()]: (state, action) => {
            state.categories = action.payload;
            state.isLoading = false;
        },
        [fetchAllCategory.rejected.toString()]: (state, action) => {
            state.categories = [];
            state.isLoading = false;
        },
        [fetchAllCategory.pending.toString()]: (state, action) => {
            state.categories = [];
            state.isLoading = true;
        },


        //Запрос тегов для текущей выбранной платформы и категории
        [fetchCurrentPlatformData.fulfilled.toString()]: (state, action) => {
            state.currentPlatform = action.payload;
            state.isLoading = false;
        },
        [fetchCurrentPlatformData.rejected.toString()]: (state, action) => {
            // state.currentPlatform = {
            //     platform: null,
            //     categories: [],
            //     editCategory: null
            // };
            state.isLoading = false;
        },
        [fetchCurrentPlatformData.pending.toString()]: (state, action) => {
            state.isLoading = true;
        },

        //Запрос категорий 2 или 1 уровня для редактирования
        [fetchCategoryEdit.fulfilled.toString()]: (state, action) => {
            state.currentPlatform = action.payload;
            state.isLoading = false;
        },
        [fetchCategoryEdit.rejected.toString()]: (state, action) => {
            state.isLoading = false;
        },
        [fetchCategoryEdit.pending.toString()]: (state, action) => {
            state.isLoading = true;
        },

        [updateEditedCategory.fulfilled.toString()]: (state, action) => {
            state.currentPlatform = action.payload;
            state.isLoading = false;
        },
        [updateEditedCategory.rejected.toString()]: (state, action) => {
            state.isLoading = false;
        },
        [updateEditedCategory.pending.toString()]: (state, action) => {
            state.isLoading = true;
        },
    }
});

export default TagAdminSlice
export const TagAdminActions = TagAdminSlice.actions
export const TagAdminSelector = (store: { tagAdmin: TagAdminSliceState }): TagAdminSliceState => store.tagAdmin;
import { Tag } from '@brg/api';
import { createSlice } from '@reduxjs/toolkit';
import { ADMIN_TAGS_TYPE } from '_deziiign/main/pages/MainTagAdminPage/types';
import { fetchAllCategory, fetchCategoryEdit, fetchCurrentPlatformData, fetchPlatformCategoryOpt, updateEditedCategory } from 'shared/actions/tagAdminActions';

export interface IPlatform {
    id: string;
    appName: string;
    context: string;
    url: string;
    entityTypes?: string[];
    entityTypesEduTags?: string[];
    entityTypesRequiredTags?: string[];
}

interface EditCategory {
    mainTag: Tag<'Local'>;
    childrens: Tag<'Local'>[];
}

interface TagAdminSliceState  {
    platforms: IPlatform[];
    categories: Tag<'Local' | 'Global'>[];
    currentPlatform?: {
        platform: IPlatform | null,
        categories: Tag<'Local' | 'Global'>[];
        editCategory: EditCategory
    }
    isLoading: boolean;
    isEditMode: boolean;
    type: ADMIN_TAGS_TYPE
}


export const TagAdminSlice = createSlice({
    name: 'tagAdmin',
    initialState: {
        categories: [],
        platforms: [],
        currentPlatform: {
            platform: null,
            categories: [],
            editCategory: null
        },
        isLoading: false,
        isEditMode: false,
        type: ADMIN_TAGS_TYPE.normal
    },
    reducers: {
        toggleEditMode: (state, action) => {
            state.isEditMode = action.payload
        },
        clear: (state) => {
            state = {  
                categories: [],
                platforms: [],
                currentPlatform: {
                    platform: null,
                    categories: [],
                    editCategory: null
                },
                isLoading: false,
                isEditMode: false
            }
        },
        setTagsType: (state,action) => {
            state.currentPlatform = action.payload?.currentPlatform
            state.isEditMode = action.payload.isEditMode
            state.type = action.payload.type
        }
    },
    extraReducers: {
        // Запрос всех категорий для текущей платформы по entityType
        [fetchPlatformCategoryOpt.fulfilled.toString()]: (state, action) => {
            state.platforms = action.payload;
            state.isLoading = false;
        },
        [fetchPlatformCategoryOpt.rejected.toString()]: (state, action) => {
            state.platforms = [];
            state.isLoading = false;
        },
        [fetchPlatformCategoryOpt.pending.toString()]: (state, action) => {
            state.platforms = [];
            state.isLoading = true;
        },

        //Запрос всех доступных категорий в базе
        [fetchAllCategory.fulfilled.toString()]: (state, action) => {
            state.categories = action.payload;
            state.isLoading = false;
        },
        [fetchAllCategory.rejected.toString()]: (state, action) => {
            state.categories = [];
            state.isLoading = false;
        },
        [fetchAllCategory.pending.toString()]: (state, action) => {
            state.categories = [];
            state.isLoading = true;
        },


        //Запрос тегов для текущей выбранной платформы и категории
        [fetchCurrentPlatformData.fulfilled.toString()]: (state, action) => {
            state.currentPlatform = action.payload;
            state.isLoading = false;
        },
        [fetchCurrentPlatformData.rejected.toString()]: (state, action) => {
            // state.currentPlatform = {
            //     platform: null,
            //     categories: [],
            //     editCategory: null
            // };
            state.isLoading = false;
        },
        [fetchCurrentPlatformData.pending.toString()]: (state, action) => {
            state.isLoading = true;
        },

        //Запрос категорий 2 или 1 уровня для редактирования
        [fetchCategoryEdit.fulfilled.toString()]: (state, action) => {
            state.currentPlatform = action.payload;
            state.isLoading = false;
        },
        [fetchCategoryEdit.rejected.toString()]: (state, action) => {
            state.isLoading = false;
        },
        [fetchCategoryEdit.pending.toString()]: (state, action) => {
            state.isLoading = true;
        },

        [updateEditedCategory.fulfilled.toString()]: (state, action) => {
            state.currentPlatform = action.payload;
            state.isLoading = false;
        },
        [updateEditedCategory.rejected.toString()]: (state, action) => {
            state.isLoading = false;
        },
        [updateEditedCategory.pending.toString()]: (state, action) => {
            state.isLoading = true;
        },
    }
});

export default TagAdminSlice
export const TagAdminActions = TagAdminSlice.actions
export const TagAdminSelector = (store: { tagAdmin: TagAdminSliceState }): TagAdminSliceState => store.tagAdmin;
